import React from "react";
import { ChevronDown } from "lucide-react";


/** Solid dark card with a display-font heading. */
export function Panel({ title, children }) {
  return (
    <section className="card-sharp p-5">
      <h2 className="font-display text-lg text-white mb-4">{title}</h2>
      {children}
    </section>
  );
}


/** Label + child wrapper for a form field. */
export function Field({ label, children }) {
  return <div><label className="label-tiny">{label}</label>{children}</div>;
}


/** Styled <select> with a chevron. `options` = [{ v, l }] */
export function Select({ value, onChange, options, ...rest }) {
  return (
    <div className="relative">
      <select {...rest} value={value} onChange={(e)=>onChange(e.target.value)}
        className="input-dark appearance-none pr-8">
        {options.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
      <ChevronDown size={14} className="absolute right-2 top-1/2 -translate-y-1/2 text-[var(--text-muted)] pointer-events-none"/>
    </div>
  );
}
